var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BigNumber } from "@ethersproject/bignumber";
import { useContext } from "react";
import { CHAINS_TO_ID, isSolanaVault, VaultAddressMap, VaultList, VaultVersionList, getAssets, } from "../constants/constants";
import { isEVMChain } from "../utils/chains";
import { SubgraphDataContext } from "./subgraphDataContext";
import { formatUnits } from "@ethersproject/units";
import { getAssetDecimals } from "../utils/asset";
var getVaultKey = function (vault) { return "vaultAccount_" + vault.replace(/-/g, ""); };
export var vaultGraphql = function (version, chain) {
    return VaultList.reduce(function (acc, vault) {
        var vaultAddress = VaultAddressMap[vault][version];
        if (!isSolanaVault(vault) &&
            (!vaultAddress || VaultAddressMap[vault].chainId !== CHAINS_TO_ID[chain])) {
            return acc;
        }
        if (isEVMChain(chain)) {
            vaultAddress = vaultAddress === null || vaultAddress === void 0 ? void 0 : vaultAddress.toLowerCase();
        }
        return (acc +
            (version === "v1"
                ? "\n          " + getVaultKey(vault) + ": vault(id: \"" + vaultAddress + "\" ){\n            id\n            name\n            symbol\n            totalBalance\n            totalPremiumEarned\n            totalWithdrawalFee\n            totalNotionalVolume\n            underlyingAsset\n            underlyingSymbol\n          }\n\n        "
                : "\n          " + getVaultKey(vault) + ": vault(id: \"" + vaultAddress + "\" ){\n            id\n            name\n            symbol\n            totalBalance\n            totalPremiumEarned\n            totalFeeCollected\n            totalNotionalVolume\n            underlyingAsset\n            underlyingSymbol\n          }\n\n        "));
    }, "");
};
export var resolveVaultsSubgraphResponse = function (responses) {
    return Object.fromEntries(VaultVersionList.map(function (version) { return [
        version,
        Object.fromEntries(VaultList.map(function (vault) {
            var vaultData = responses[version]
                ? responses[version][getVaultKey(vault)]
                : undefined;
            return [
                vault,
                vaultData
                    ? __assign(__assign({}, vaultData), { totalBalance: BigNumber.from(vaultData.totalBalance) }) : undefined,
            ];
        })),
    ]; }));
};
export var resolvePortfolioValueResponse = function (data, currrentPrice) {
    //USD 
    /********************************/
    // let totalPrice: number = 0;
    // if (data && (data["bETH-THETA"] || data["bBTC-THETA"] || data["bBUSD-ETH-P-THETA"] || data["bBNB-THETA"])) {
    //   // let ethBalance = parseFloat(formatUnits(data["bETH-THETA"].totalBalance, getAssetDecimals(getAssets("bETH-THETA"))));
    //   // let btcBalance = parseFloat(formatUnits(data["bBTC-THETA"] .totalBalance, getAssetDecimals(getAssets("bETH-THETA"))));
    //   // let usdcBalance = parseFloat(formatUnits(data["bBUSD-ETH-P-THETA"].totalBalance, getAssetDecimals(getAssets("bETH-THETA"))));
    //   let bnbBalance = parseFloat(formatUnits(data["bBNB-THETA"].totalBalance, getAssetDecimals(getAssets("bBNB-THETA"))));
    //   currrentPrice.map(item => {
    //     switch (item.base) {
    //       // case "ETH":
    //       //   totalPrice += ethBalance ? (ethBalance * (item.price)) : 0;
    //       //   break;
    //       // case "BTC":
    //       //   totalPrice += btcBalance ? (btcBalance * (item.price)) : 0;
    //       //   break;
    //       // case "BUSD":
    //       //   totalPrice += usdcBalance ? (usdcBalance * (item.price)) : 0;
    //       //   break;
    //       case "BNB":
    //         totalPrice += bnbBalance ? (bnbBalance * (item.price)) : 0;
    //         break;
    //     }
    //   })
    // }
    // return totalPrice;
    /********************************/
    var totalPrice = 0;
    if (data && data["bBNB-THETA"]) {
        totalPrice = parseFloat(formatUnits(data["bBNB-THETA"].totalBalance, getAssetDecimals(getAssets("bBNB-THETA"))));
    }
    return totalPrice;
};
export var useVaultsSubgraphData = function () {
    var contextData = useContext(SubgraphDataContext);
    return {
        data: contextData.vaultSubgraphData.vaults,
        loading: contextData.vaultSubgraphData.loading,
    };
};
//# sourceMappingURL=useVaultData.js.map